export interface MediaSize {
  size: string,
  src: string,
  height: number,
  width: number
}

export interface MediaPalette {
  Vibrant: [number, number, number]
  Muted: [number, number, number]
  DarkVibrant: [number, number, number]
  DarkMuted: [number, number, number]
  LightVibrant: [number, number, number]
  LightMuted: [number, number, number]
}

export interface IMedia {
  _id: string
  
  audio: {
    src: string
  }
  
  directory: string

  palette: MediaPalette
  medias: MediaSize[]
}

export const MEDIA_SIZES = [ 'xl', 'l', 'm', 's', 'xs' ]

export interface Media extends IMedia {}

export class Media implements IMedia {

  constructor(props: IMedia) {
    Object.assign(this, {
      ...props
    })
  }

  public getMedia (size: string): MediaSize | null {
    if (!this.medias) return null

    let media = null
    let failSafe = 0

    const targetSize = MEDIA_SIZES.indexOf(size)
    const sizes = [ ...MEDIA_SIZES ].slice(targetSize, MEDIA_SIZES.length - 1)

    while (!media && sizes.length && failSafe < 10) {
      media = this.medias.find(m => m.size === sizes[0])
      sizes.shift()

      failSafe++
    }

    return media ?? null
  }

  public getSize (size: string): string | undefined {
    if (!this.medias) return ''
    return this.getMedia(size)?.src
  }

  public getWidth (size: string): number {
    if (!this.medias) return 0

    return this.getMedia(size)?.width ?? 0
  }

  public getHeight (size: string): number {
    if (!this.medias) return 0

    return this.getMedia(size)?.height ?? 0
  }

  public getRatio = (
    size: string,
    maxWidth: number,
    maxHeight: number
  ) => {
    const ratio = Math.min(maxWidth / this.getWidth(size), maxHeight / this.getHeight(size))
    
    return {
      width: Math.round(this.getWidth(size) * ratio),
      height: Math.round(this.getHeight(size) * ratio)
    }
  }
}